import axios from 'axios';
import settings from 'config';

const protocol = settings.PROTOCOL || 'http';
const expressIP = settings.API_URL || 'localhost';
const expressPort = Number(settings.API_PORT) || 3333;
const apiPath = settings.API_PATH || '';
const baseUrl = `${protocol}://${expressIP}:${expressPort}${apiPath}`;

const api = axios.create({
  baseURL: baseUrl,
});

function getAccessToken() {
  return localStorage.getItem('accessToken');
}

async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await axios.post(`${baseUrl}/auth/refreshToken`, {
      refreshToken,
    });
    const newAccessToken = response.data.accessToken;
    localStorage.setItem('accessToken', newAccessToken);
    return newAccessToken;
  } catch (refreshError) {
    console.error('Error refreshing token:', refreshError);
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
    throw refreshError;
  }
}

api.interceptors.request.use(async (request) => {
  const accessToken = getAccessToken();
  request.headers['Authorization'] = `Bearer ${accessToken}`;
  return request;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const originalRequest = error?.config;

    if (!status || !originalRequest) return Promise.reject(error);

    // Ignore auth endpoints
    const url = originalRequest.url || '';
    if (url.includes('/auth/')) {
      return Promise.reject(error);
    }

    // Unauthorized error, redirect to login
    if (status === 403) {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('accessToken');
      window.location.href = '/auth/login';
      return Promise.reject(error);
    }

    // Unauthorized error, attempt to refresh the token
    if (status === 401) {
      try {
        const newAccessToken = await refreshAccessToken();
        // Update the original request with the new token and retry
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return axios(originalRequest);
      } catch (refreshError) {
        // Handle refresh token failure
        return Promise.reject(refreshError);
      }
    }
    // For other error responses, simply return the error
    return Promise.reject(error);
  }
);

export { api };
